/** Settings > Communications > Outage Notifications: the settings and the editable email wording. */
import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import OutageNotificationsSettings from './OutageNotificationsSettings';
import OutageEmailTemplatesSettings from './OutageEmailTemplatesSettings';

const OutageNotificationsTab: React.FC = () => {
  const [sub, setSub] = useState<'settings' | 'templates'>('settings');
  return (
    <Box>
      <Tabs value={sub} onChange={(_, v) => setSub(v)} sx={{ mb: 2, minHeight: 40, '& .MuiTab-root': { minHeight: 40, textTransform: 'none' } }}>
        <Tab value="settings" label="Settings" />
        <Tab value="templates" label="Email templates" />
      </Tabs>
      {sub === 'settings' ? <OutageNotificationsSettings /> : <OutageEmailTemplatesSettings />}
    </Box>
  );
};

export default OutageNotificationsTab;
